import React from 'react';

import { v as bvVar } from 'bv';
import { Ambassador } from 'bv-components';

// TODO: Use ambassador-component to remove the padding added by left-component
// We could pass the className to the ambassador, as the ambassador will need a wrapper
// It will depend on Ambassador templating, yet to be done

const AmbassadorComponent = () => bvVar('ambassador') && (
  <div className="left-component ambassador-component">
    <Ambassador />
  </div>
);

export default AmbassadorComponent;
